import "./src/styles/global.css"
import "./src/styles/icon-font.css"

import { GatsbyBrowser } from "gatsby"
import React from "react"
import WrapPage from "./src/gatsby-api/wrap-page"
import WrapRoot from "./src/gatsby-api/wrap-root"

const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
    return <WrapRoot>{element}</WrapRoot>
}
const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
    return <WrapPage>{element}</WrapPage>
}

export { wrapPageElement, wrapRootElement }
